"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import PaymentNewView from "@/views/payItems/components/PaymentNewView.vue";
import { ModelBuilderUtil } from "@ym-framework/model";
import { AccountSessionMixins } from "@/service/account-session";
import NoticeDialog from "@/components/layout/components/dialog/NoticeDialog.vue";
import BlockDialog from "@/components/layout/components/dialog/BlockDialog.vue";
let PaymentMain = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.style = "";
    this.title = this.$t("paymentmain.open_new");
    this.alert = "";
    this.loading = true;
    this.vds = [];
    this.shop_id = null;
    this.is_delete = false;
    this.recommand = null;
    this.choose_type = null;
    this.recommand_id = null;
  }
  mounted() {
    if (this.$route.query.hasOwnProperty("style")) {
      this.style = this.$route.query.style;
      if (this.style === "create") {
        if (this.$route.params.shop_id !== void 0) {
          this.shop_id = this.$route.params.shop_id;
          if (this.$route.params.is_delete === "true") {
            this.is_delete = true;
          } else {
            this.is_delete = false;
          }
        }
        if (this.$route.params.recommand !== void 0) {
          this.recommand = this.$route.params.recommand;
        }
        if (this.$route.params.hasOwnProperty("type")) {
          this.choose_type = this.$route.params.type;
        }
        if (this.$route.query.rid && this.$route.query.rid !== "") {
          this.recommand_id = this.$route.query.rid;
        }
        this.title = this.$t("paymentmain.open_new");
        this.alert = this.$t(
          "paymentmain.cannot_be_returned_after_purchase"
        );
      }
      if (this.style === "renew") {
        this.title = this.$t("paymentmain.renewal");
        if (this.$route.params.hasOwnProperty("item")) {
          let arr = [];
          let item = ModelBuilderUtil.builder(
            JSON.parse(
              this.$route.params.item
            )
          );
          arr.push(item);
          this.vds = arr;
        }
        if (this.$route.params.hasOwnProperty("items")) {
          let arr = [];
          let _jsonObj = JSON.parse(this.$route.params.items);
          for (const virtualdesktopitem of _jsonObj.vds) {
            let item = ModelBuilderUtil.builder(
              virtualdesktopitem
            );
            arr.push(item);
          }
          this.vds = arr;
        }
        this.alert = "";
      }
      if (this.style === "update") {
        this.title = this.$t("paymentmain.upgrade");
        this.alert = this.$t("paymentmain.upgrade_and_change");
        if (this.$route.params.hasOwnProperty("item")) {
          let arr = [];
          let _jsonObj = JSON.parse(
            this.$route.params.item
          );
          let item = ModelBuilderUtil.builder(_jsonObj);
          arr.push(item);
          this.vds = arr;
        }
      }
      if (this.style === "recycle") {
        this.title = this.$t("paymentmain.recovery");
        this.alert = this.$t(
          "paymentmain.on_the_basis_of_retaining_the_computer_environment_it_will_be_replaced_for_you_"
        );
        if (this.$route.params.hasOwnProperty("item")) {
          let arr = [];
          let _jsonObj = JSON.parse(
            this.$route.params.item
          );
          let item = ModelBuilderUtil.builder(_jsonObj);
          arr.push(item);
          this.vds = arr;
        }
      }
    }
  }
  openNotice() {
    return __async(this, null, function* () {
      var _a;
      if ((_a = this.$session) == null ? void 0 : _a.marks.is("KV_INTERNAL_USER")) {
      } else {
        this._block_dialog.open();
      }
    });
  }
  // openNotice(){
  //   // 打开紧急通知弹窗拦截任何操作
  //   //存在这个mark则不弹窗
  //   if(this.$session?.marks.is('KV_INTERNAL_USER')){
  //     //do nothing
  //   }else{
  //     this._noticeDialog.open();
  //   }
  // }
  openRegionWindow() {
    window.open("https://www.kuajingvs.com/custom-service/", "_blank");
  }
  toConnectUs() {
    window.open("https://wpa1.qq.com/FzfSmq8R?_type=wpa&qidian=true", "_blank");
  }
  isReady(data) {
    this.loading = !data;
  }
  goBack() {
    this.$router.push("/");
  }
};
__decorateClass([
  Ref("noticeDialog")
], PaymentMain.prototype, "_noticeDialog", 2);
__decorateClass([
  Ref("blockDialog")
], PaymentMain.prototype, "_block_dialog", 2);
PaymentMain = __decorateClass([
  Component({
    components: {
      PaymentNewView,
      NoticeDialog,
      BlockDialog
      // DragDialog,
    }
  })
], PaymentMain);
export {
  PaymentMain as default
};
